// extracted by mini-css-extract-plugin
export default {"feedbackPopover":"GiveFeedbackPopover-module__feedbackPopover--mopJ5"};